import React from "react";
import { Section, sectionSpacingY } from "components/section";
import { TextTitle } from "ui/text";
import Image from "next/image";
import { Flex, Box } from "@chakra-ui/react";

type Investor = {
  name: string;
  src: string;
};

const investors: Investor[] = [
  {
    name: "Iconiq",
    src: "https://cdn.sanity.io/images/pwmfmi47/production/376ac6715d21daa7121e3314419b2b9db28441d8-202x48.svg",
  },
  {
    name: "Amplify Partners",
    src: "https://cdn.sanity.io/images/pwmfmi47/production/c9f48501c144abcc8c6d3d06d1d670491e1d23e1-172x48.svg",
  },
  {
    name: "Bain Capital Ventures",
    src: "https://cdn.sanity.io/images/pwmfmi47/production/d3bd5f8f57faf96b1b3ae8308dd27a17ba14cc21-133x48.svg",
  },
  {
    name: "HubSpot",
    src: "https://cdn.sanity.io/images/pwmfmi47/production/7d7fefee1dace676a299ed123f038894603cf94d-170x48.svg",
  },
  {
    name: "Databricks",
    src: "https://cdn.sanity.io/images/pwmfmi47/production/59e4fdd3b5ef082d0e991df58b6539be1dad4067-132x22.svg",
  },
];

export function Investors() {
  return (
    <Section my="0" pb={sectionSpacingY}>
      <TextTitle
        size="sm"
        align="center"
        mobileAlign="center"
        title="Backed by the top VCs and industry leading software companies"
        mb="biggest"
        maxW={{ base: "md", md: "2xl" }}
      />

      <Flex
        justifyContent="center"
        flexWrap="wrap"
        rowGap="bigger"
        columnGap={{ base: "bigger", md: "biggest" }}
        maxW={{ base: "400px", md: "xl", lg: "100%" }}
        mx="auto"
      >
        {investors.map((investor) => (
          <Box key={investor.name} h={{ base: "24px", sm: "28px", md: "36px" }}>
            <Image
              width="200"
              height="40"
              src={investor.src}
              alt={`${investor.name} logo.`}
              style={{ objectFit: "contain", width: "auto", height: "100%", maxWidth: "200px", maxHeight: "36px" }}
            />
          </Box>
        ))}
      </Flex>
    </Section>
  );
}
